import { ValidateResult } from './';
export class Corporation {
    constructor(data) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.name = data.name;
    }
}
export class CorporationEmployee {
    constructor(data) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "corporationId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "employeeCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.userId = data.userId;
        this.corporationId = data.corporationId;
        this.name = data.name;
        this.employeeCode = data.employeeCode;
    }
}
export class CorporationEmployeeParams {
    constructor(name, employeeCode) {
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "employeeCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name;
        this.employeeCode = employeeCode;
    }
    toJson() {
        return { name: this.name, employeeCode: this.employeeCode };
    }
    // 法人関連のパラメータをアップデートするパラメータのバリデーション
    validate() {
        const result = new ValidateResult();
        if (this.employeeCode === '') {
            result.pushErrorMessage('社員コードを入力してください');
        }
        if (this.name === '') {
            result.pushErrorMessage('社員名を入力してください');
        }
        return result;
    }
}
